import { Box, Stack, Grid } from '@mui/joy'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'
import { Button } from '../../Button'
import { Section } from '../../Section'
import { Text } from '../../Text'

export default function FinancingTable({ blocks = [], primaryBtn }) {
    const { t } = useTranslation('grants')
    return (
        <Section py={30} backgroundColor="#fff">
            <Stack spacing={10}>
                {blocks.map((block, rowIndex) => (
                    <Box
                        bgcolor="#fff"
                        padding="30px"
                        // eslint-disable-next-line react/no-array-index-key
                        key={`Row-${rowIndex}`}
                    >
                        <Grid container spacing="15px" alignItems="center">
                            <Grid md={10} sm={12} container height="100%">
                                <Grid md={6} sm={12}>
                                    <Text
                                        fontWeight={700}
                                        pb="15px"
                                        color="#0d417d"
                                    >
                                        {block.grantTitle}
                                    </Text>
                                    <Text>{block.grantDescription}</Text>
                                </Grid>
                                <Grid md={2} sm={4} />
                                <Grid
                                    md={2}
                                    sm={4}
                                    borderLeft="1px solid #e3eff6"
                                >
                                    <Text
                                        fontWeight={700}
                                        pb="15px"
                                        color="#0d417d"
                                    >
                                        {t('amount')}
                                    </Text>
                                    <Text>{block.amount}</Text>
                                </Grid>
                                <Grid
                                    md={2}
                                    sm={4}
                                    borderLeft="1px solid #e3eff6"
                                >
                                    <Text
                                        fontWeight={700}
                                        pb="15px"
                                        color="#0d417d"
                                    >
                                        {t('deadline')}
                                    </Text>
                                    <Text>{block.deadline}</Text>
                                </Grid>
                            </Grid>
                            <Grid md={2} sm={12} height="100%">
                                <Link
                                    target="_blank"
                                    href={primaryBtn?.link || '#'}
                                >
                                    <Button
                                        size="sm"
                                        width="100%"
                                        mb={4}
                                        borderRadius="36px"
                                        disabled={block?.disabled}
                                        variant={block.primaryBtnVariant}
                                    >
                                        {primaryBtn?.title}
                                    </Button>
                                </Link>

                                <Link
                                    target="_blank"
                                    href={block?.buttonLink || '#'}
                                >
                                    <Text
                                        textAlign="center"
                                        color={block.secondaryBtnColor}
                                        fontSize=".9rem"
                                        sx={{
                                            cursor: [block.secondaryBtnCursor],
                                            '&:hover': {
                                                textDecoration: 'underline',
                                            },
                                        }}
                                    >
                                        {block?.buttonName}
                                    </Text>
                                </Link>
                            </Grid>
                        </Grid>
                    </Box>
                ))}
            </Stack>
        </Section>
    )
}
